import React, { useState, useEffect } from 'react';
import { getProductos, saveProducto, deleteProducto } from '../../services/ProductService';
import { getCategorias, saveCategoria } from '../../services/CategoriasService';

// Estilos
import '../static/Global.css';
import '../static/Home.css';
import '../static/Aside.css';
import '../static/Flotante.css';
import '../static/Busqueda.css';

function DashboardProductos() {
    const [productos, setProductos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [categorias, setCategorias] = useState([]);

    // Se eliminaron mostrarLista y nuevaCategoria para limpiar los warnings de ESLint
    const [formData, setFormData] = useState({
        productos_id: '',
        nombre: '',
        categoria: '',
        precio_venta: '', 
        imagen: '',
        descripcion: ''
    });

    useEffect(() => {
        cargarLista();
        cargarCategorias();
    }, []);

    const cargarLista = async () => {
        try {
            const data = await getProductos();
            setProductos(data);
            setLoading(false);
        } catch (error) {
            console.error("Error en Novatech:", error);
            setLoading(false);
        }
    };

    const cargarCategorias = async () => {
        try {
            const data = await getCategorias();
            setCategorias(data);
        } catch (error) {
            console.error("Error cargando categorias", error);
        }
    };

    const crearCategoria = async () => {
        const nombre = prompt("Nombre de la nueva categoría");
        if (!nombre) return;
        try {
            await saveCategoria({ nombre });
            await cargarCategorias();
            alert("Categoría creada");
        } catch (error) {
            alert("Error creando categoría");
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await saveProducto(formData);
            alert("¡Producto guardado correctamente!");
            closeModal();
            cargarLista();
        } catch (error) {
            alert("Error al guardar: " + error.message);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("¿Estás seguro de eliminar este producto?")) {
            try {
                await deleteProducto(id);
                cargarLista();
                alert("Producto eliminado correctamente.");
            } catch (error) {
                alert("Error al eliminar");
            }
        }
    };

        //Lógica de filtrado 
    const productosFiltrados = productos.filter(p => 
        p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
        p.productos_id.toString().includes(busqueda) ||
        p.categoria.toLowerCase().includes(busqueda.toLowerCase())
    );

    const openModal = (prod = null) => {
        if (prod) {
            setFormData({
                productos_id: prod.productos_id,
                nombre: prod.nombre,
                categoria: prod.categoria,
                precio_venta: prod.precio_venta || '', // 👈 Esto llena el precio al editar
                imagen: prod.imagen,
                descripcion: prod.descripcion || ''
            });
        } else {
            setFormData({
                productos_id: '',
                nombre: '',
                categoria: '',
                precio_venta: '',
                imagen: '',
                descripcion: ''
            });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h2>LISTADO DE PRODUCTOS</h2>

                {/* BARRA DE BÚSQUEDA */}
                <div className="search-container" >
                    <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
                    <input 
                        type="text"
                        className="search-input"
                        placeholder="Buscar por nombre, ID o categoría..."
                        style={{ paddingLeft: '35px', width: '100%', borderRadius: '8px', border: '1px solid #ddd', height: '40px' }}
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>

                    <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
                        <i className="fa fa-plus"></i> Nuevo Producto
                    </button>
                </div>


            <div className="table-responsive">
                <table className="novatech-table">                    
                <thead>
                    <tr>
                        <th>Imagen</th>
                        <th>Nombre</th>
                        <th>Categoría</th>
                        <th>Precio</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
    <tbody>
        {loading ? (
            <tr>
                <td colSpan="5">cargando productos...</td>
            </tr>
        ) :  (
            productosFiltrados.map((p) => (
                <tr key={p.productos_id}>
                    <td data-label="Imagen">
                        <img 
                            src={p.imagen} 
                            alt={p.nombre} 
                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ccc' }} 
                        />
                    </td>
                    <td data-label="Nombre">{p.nombre}</td>
                    <td data-label="Categoría">{p.categoria}</td>
                    <td data-label="Precio">S/ {Number(p.precio_venta || 0).toFixed(2)}</td>
                    <td data-label="Acciones" className="actions-cell">
                        <button className="btn-edit" onClick={() => openModal(p)}>
                            <i className="fa fa-edit"></i> Editar
                        </button>
                        <button className="btn-delete" onClick={() => handleDelete(p.productos_id)}>
                            <i className="fa fa-trash"></i> Eliminar
                        </button>
                    </td>
                 </tr>
            ))
         )}
        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex' }}>
                    <div className="modal-content">
                        <form onSubmit={handleSave}>
                            <h2>{formData.id ? "EDITAR PRODUCTO" : "NUEVO PRODUCTO"}</h2>
                            
                            <div className="form-group">
                                <label>Nombre del Producto:</label>
                                <input type="text" value={formData.nombre} required onChange={(e) => setFormData({...formData, nombre: e.target.value})} />
                            </div>

                            <div className="form-group">
                                <label>Categoría:</label>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <select value={formData.categoria} required onChange={(e) => setFormData({...formData, categoria: e.target.value})}>
                                        <option value="">Seleccione categoría</option>
                                        {categorias.map((c) => (
                                            <option key={c.id} value={c.nombre}>{c.nombre}</option>
                                        ))}
                                    </select>
                                    <button type="button" className="btn-save" onClick={crearCategoria}>+</button>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Precio (S/):</label>
                                <input 
                                    type="number" 
                                    step="0.01" 
                                    value={formData.precio_venta} // 👈 Vinculado correctamente
                                    required 
                                    onChange={(e) => setFormData({...formData, precio_venta: e.target.value})} 
                                />
                            </div>

                            <div className="form-group">
                                <label>URL de la Imagen:</label>
                                <input type="text" value={formData.imagen} required onChange={(e) => setFormData({...formData, imagen: e.target.value})} />
                            </div>

                            <div className="form-group">
                                <label>Descripción:</label>
                                <textarea rows="3" value={formData.descripcion} onChange={(e) => setFormData({...formData, descripcion: e.target.value})}></textarea>
                            </div>

                            <div className="actions">
                                <button type="submit" className="btn-save">Guardar Cambios</button>
                                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
}

export default DashboardProductos;